import React from 'react';
import { ShieldCheck, Leaf, Lightbulb, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { companyInfo } from '../data/mock';

const iconMap = {
  'shield-check': ShieldCheck,
  'leaf': Leaf,
  'lightbulb': Lightbulb,
  'users': Users
};

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About EGESEA
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {companyInfo.description}
          </p>
        </div>

        {/* Mission Statement */}
        <div className="max-w-4xl mx-auto mb-20">
          <Card className="bg-gradient-to-br from-amber-50 to-green-50 border-2 border-amber-200">
            <CardContent className="p-8 md:p-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                {companyInfo.mission}
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Company Values */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Our Core Values
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {companyInfo.values.map((value) => {
              const IconComponent = iconMap[value.icon];
              return (
                <Card 
                  key={value.title}
                  className="text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 hover:border-amber-400"
                >
                  <CardContent className="p-6">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-4">
                      <IconComponent className="w-8 h-8 text-amber-600" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-900 mb-3">
                      {value.title}
                    </h4>
                    <p className="text-gray-600 leading-relaxed">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Image Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="relative h-80 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/uti2frsn_State-of-the-Art%20Facilities.jpeg"
              alt="Manufacturing Facility"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <h4 className="text-2xl font-bold text-white">State-of-the-Art Facilities</h4>
            </div>
          </div>
          <div className="relative h-80 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_eyco-refinery/artifacts/1ky1sguo_Rigorous%20Quality%20Control.jpeg"
              alt="Quality Control"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <h4 className="text-2xl font-bold text-white">Rigorous Quality Control</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
